import React, { useEffect } from 'react';
import LoginBody from '../components/login/LoginBody';

interface Props {
    //redirect page after login
    redirectTo?: string;
}
const LoginScreen: React.FC<Props> = ({ redirectTo }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            style={{
                backgroundColor: 'white',
                width: '100%',
                maxWidth: '1240px',
                margin: '0 auto',
                padding: '30px 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <h1>ENTRAR</h1>
            <LoginBody redirectTo={redirectTo} />
        </div>
    );
};

export default LoginScreen;
